import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Toast from "../../plugins/useToast";
import {ReactComponent as IconErrorBig} from '../../assets/icons/ic-error-big.svg'

const AudioModal = ({ type, handleRetry, handleOk }) => {
    const { t } = useTranslation()
    const downloadUrl = process.env.REACT_APP_AUDIO_MANAGE_DOWNLOAD_URL
    const [warningChecked, setWarningChecked] = useState(false)

    const handleDownload = async () => {
        try {
            const response = await fetch(downloadUrl);
            if (!response.ok) throw new Error('Network response was not ok.');
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            // 파일 이름을 URL에서 추출하거나 기본값을 설정합니다.
            const filename = downloadUrl.substring(downloadUrl.lastIndexOf('/') + 1) || 'audio_program';
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
            // 사용자에게 다운로드 실패를 알리는 로직을 추가할 수 있습니다.
            Toast({ isSuccess: false, msg: t(`login.unknownError`) });
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50" style={{ zIndex: 10000 }}>
            <div className="w-[390px] bg-[#DEDEDE]" style={{ borderRadius: 8, boxShadow: '0px 12px 12px 0px #00000099', zIndex: 5 }}>  
                <div className="flex items-center bg-[#CECECE] h-[38px]" style={{ padding: '10px 20px', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
                    <span className="text-black" style={{ fontSize: 16, fontWeight: 400, lineHeight: '17.6px' }}>{type === 'autoPlay' ? t('audioModal.notice') : type === 'connection' ? t('audioModal.connectionTitle') : t('audioModal.warning')}</span>
                </div>
                <div className="flex flex-col items-center" style={{ paddingTop: 20, paddingLeft: 20, paddingRight: 20, marginBottom: 8 }}>
                    <IconErrorBig style={{ marginBottom: 10 }}/>
                    {
                        type === 'connection' &&
                        <>
                            <span className="" style={{ fontWeight: 500, lineHeight: '140%' }}>{t('audioModal.connectionMessage1')}</span>
                            <span className="" style={{ fontWeight: 500, lineHeight: '140%' }}>{t('audioModal.connectionMessage2')}</span>
                        </>
                    }
                    {
                        type === 'autoPlay' &&
                        <>
                            <span className="" style={{ fontWeight: 500, lineHeight: '140%' }}>{t('audioModal.autoPlayMessage')}</span>
                        </>
                    }
                    {
                        type === 'warning' &&
                        <>                           
                            <p className="" style={{ fontWeight: 500, lineHeight: '140%' }}>{t('audioModal.warningMessage1')} {t('audioModal.warningMessage2')} {t('audioModal.warningMessage3')}</p>
                            <div className="h-[1px] w-full mt-[10px]" />
                            <label className="flex gap-[4px] mt-[10px]">
                                <input
                                    type="checkbox"
                                    checked={warningChecked}   
                                    onChange={e => { setWarningChecked(e.target.checked) }}
                                />
                                <span className="mb-[6px] font-light cursor-pointer" style={{ fontSize: 14 }}>{t('audioModal.warningAccept')}</span>
                            </label>
                        </>
                    }
                </div>
                <div className="flex justify-between items-center" style={{ justifyContent: type === 'warning' ? 'end' : '', paddingLeft: type === 'warning' ? 20 : 0, paddingRight: 20, paddingBottom: 12 }}>
                    {
                        type === 'warning' ?
                        <div className="flex-1 flex justify-between items-center">
                            <span onClick={handleDownload} className="cursor-pointer" style={{ fontWeight: 500, textDecoration: 'underline' }}>{t('audioModal.download')}</span>
                            <div onClick={() => { handleRetry() }} className="flex justify-center mr-2 items-center cursor-pointer w-[88px] h-[28px] bg-gradient-to-b from-[#FFFFFF] to-[#DEDEDE] rounded-[6px] font-light" style={{ fontSize: 16, border: '1px solid', borderImageSource: 'linear-gradient(180deg, #B8B8B8 0%, #B0B0B0 100%)' }}>{t('audioModal.retry')}</div>
                        </div>
                        : <div />
                    }
                    <div onClick={() => {if ((type === 'warning' && warningChecked) || type !== 'warning') handleOk()}} className="flex justify-center items-center cursor-pointer w-[88px] h-[28px] bg-gradient-to-b from-[#5E5E5E] to-[#383838] text-white rounded-[6px] font-light" style={{ opacity: type !== 'warning' ? 1 : (warningChecked ? 1 : 0.5), cursor: type !== 'warning' ? 'pointer' : (warningChecked ? 'pointer' : 'default'), fontSize: 16, border: '1px solid #5E5E5E' }}>{t('audioModal.ok')}</div>
                </div>
            </div>
        </div>
    )
}

export default AudioModal